import { Width } from '../../utils/mediaWidth/mediaWidth';

const { clientWidth, clientHeight } = document.documentElement;

const getScreenSize = () => {
    const mediaWidth = Object.values(Width).reverse()
        .find((width) => window.innerWidth >= width);
    switch (mediaWidth) {
    case (Width.S):
        return 's';
    case (Width.M):
        return 'm';
    case (Width.L):
        return 'l';
    default:
        return 'xl';
    }
};

export { clientWidth, clientHeight };
export default getScreenSize;
